import styled from 'styled-components';

import colors from '../../styles/colors';

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const Message = styled.div`
  width: 100%;
  margin: 20px 0 10px 0;
  color: ${colors.shades.gamma14};
  font-size: 12px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: flex-start;
`;

const StoreBadge = styled.img`
  width: 150px;
  height: auto;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export {
  Container,
  Message,
  ButtonsContainer,
  StoreBadge,
};
